import { render, staticRenderFns } from "./LoaderNaf.vue?vue&type=template&id=381cc665&scoped=true"
import script from "./LoaderNaf.vue?vue&type=script&lang=js"
export * from "./LoaderNaf.vue?vue&type=script&lang=js"
import style0 from "./LoaderNaf.vue?vue&type=style&index=0&id=381cc665&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "381cc665",
  null
  
)

export default component.exports